import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/jobs/career-background.png")